export const testRideAction = {
  SET_TESTRIDE_DATA: "SET_TESTRIDE_DATA",
  FETCH_TESTRIDE_SCOOTER: "FETCH_TESTRIDE_SCOOTER",
  FETCH_TESTRIDE_PATH: "FETCH_TESTRIDE_PATH",
  FETCH_TESTRIDE_EXHIBITIONS: "FETCH_TESTRIDE_EXHIBITIONS",
  SET_TESTRIDE_HISTORY: "SET_TESTRIDE_HISTORY",
  UPDATE_TESTRIDE_HISTORY: "UPDATE_TESTRIDE_HISTORY",
  SET_LANDING_HISTORY: "SET_LANDING_HISTORY",

  setTestRideState: (data) => ({
    type: testRideAction.SET_TESTRIDE_DATA,
    payload: data,
  }),

  fetchTestRideScooter: (storeId) => ({
    type: testRideAction.FETCH_TESTRIDE_SCOOTER,
    payload: { storeId: storeId },
  }),

  fetchTestRidePath: () => ({
    type: testRideAction.FETCH_TESTRIDE_PATH,
  }),

  fetchTestRideExhibitions: () => ({
    type: testRideAction.FETCH_TESTRIDE_EXHIBITIONS,
  }),

  setTestRideHistory: (postData, url, postParameter, nextState) => ({
    type: testRideAction.SET_TESTRIDE_HISTORY,
    payload: { postData: postData, url: url, postParameter: postParameter, nextState: nextState },
  }),

  updateTestRideHistory: (postData, status, nextState, callback) => ({
    type: testRideAction.UPDATE_TESTRIDE_HISTORY,
    payload: { postData: postData, status: status, nextState: nextState, callback },
  }),

  setLandingHistory: (postData, url, postParameter, nextState) => ({
    type: testRideAction.SET_LANDING_HISTORY,
    payload: { postData: postData, url: url, postParameter: postParameter, nextState: nextState },
  }),
}
